



































import { initalizeGoogleMaps } from '@/services/maps';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import gmapsStyle from "./gmaps-style.json";
import AgroIcon from "@/components/agroIcons/AgroIcons.vue";
import { LocationPayload } from './types';
import { FarmCentroid } from '@/api/farms/types';
import MarkerClustererPlus from '@google/markerclustererplus';
import * as farmsApi from "@/api/farms";
import { FarmMapSummary } from "@/api/farms/types";
import { wrapGeometryObject } from "@/helpers/geojson";
import Geometry from 'ol/geom/Geometry';
import { GeoJSONGeometry } from 'ol/format/GeoJSON';

@Component({
   name: 'FarmsMap',
   components: {
     AgroIcon,
   }
})
export default class FarmsMap extends Vue {
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop({ type: String, default: "base-style" })
  private mapClass!: string;

  @Prop({ type: Boolean, default: false})
  private noControls!: boolean;

  @Prop({type: Array, default: () => []})
  private farmsCentroids!: FarmCentroid[];
  private farmMarkers: MarkerClustererPlus | null = null;

  @Prop({ required: true, default: () => ({
      lat: -14.8406317,
      lng: -50.6837379,
      zoom: 4,
  
    }),
  })
  private startLocation!: LocationPayload;

  private wrappedMap: google.maps.Map<Element> | null = null;
  private readyToShow: boolean = false;
  private coordinatesString: string = '';
  private listeners: google.maps.MapsEventListener[] = [];
  private infoWindow: google.maps.InfoWindow | null = null;
  private farmMapSummary: FarmMapSummary | null = null; 
  private isLoading: boolean = false;

  private mounted() {
    requestAnimationFrame(async () => {
      await initalizeGoogleMaps(this.initMap);
    });
    const vm = this;

    // @ts-ignore
    window.viewMore = (uuid: string) => {
      vm.viewMore(uuid);
    }
  }

  @Watch("startLocation")
  private startLocationChange(location: LocationPayload) {
    this.wrappedMap?.setZoom(location.zoom);
    this.wrappedMap?.setCenter({
        lat: location.lat,
        lng: location.lng,
      })
  }

  private beforeDestroy() {
    this.unregisterListeners();
  }

  private initMap() {
    const mapOptions: google.maps.MapOptions = {
      center: {
        lat: this.startLocation.lat,
        lng: this.startLocation.lng,
      },
      zoom: this.startLocation.zoom,
      zoomControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      mapTypeId: "hybrid",
      styles: gmapsStyle as google.maps.MapTypeStyle[],
    };

    this.wrappedMap = new window.google.maps.Map(
      this.$refs.mapElement as Element,
      mapOptions,
    )

    this.setupPolygonStyle();

    if (!this.noControls) {
      requestAnimationFrame(() => {
        window.google.maps.event.addListenerOnce(this.wrappedMap!, 'tilesloaded', () => {
          this.readyToShow = true;
        });

        this.initCoordinatesLabel(this.$refs.coordinateLabel as HTMLElement);
        this.placeMapControls();
        this.initBoundsTracking();
      });
    }

    requestAnimationFrame(() => {
      this.insertFarmMarkers(this.farmsCentroids);
    })
  };

  private placeMapControls() {
    this.placeControl(
      this.$refs.mapControls as HTMLElement,
      window.google.maps.ControlPosition.RIGHT_CENTER
    );
  }

  private initCoordinatesLabel(element: HTMLElement) {
    this.placeControl(element, window.google.maps.ControlPosition.RIGHT_TOP);
    this.registerListener(
      this.wrappedMap!.addListener("mousemove", (event) => {
        this.displayCoordinates(event.latLng);
      })
    );
  }

  private initBoundsTracking() {
    this.registerListener(
      this.wrappedMap!.addListener('idle', () => {
        const center = this.wrappedMap!.getCenter();
        const payload = {
          zoom: this.wrappedMap!.getZoom(),
          lat: center.lat(),
          lng: center.lng(),
        }
        this.$emit('boundschanged', payload);
      })
    )
  }

  private placeControl(
    element: HTMLElement,
    position: google.maps.ControlPosition
  ) {
    this.wrappedMap!.controls[position].push(element);
  }


  @Watch('farmsCentroids')
  private updateFarmMarkers(farmsCentroids: FarmCentroid[]) {
    if (!!this.wrappedMap!) {
      this.removeFarmMarkers();
      this.insertFarmMarkers(farmsCentroids);
    }
  }

  private insertFarmMarkers(farmsCentroids: FarmCentroid[]) {
    const markers=farmsCentroids.map(this.prepareMarkerInfo);

    this.farmMarkers=new MarkerClustererPlus(this.wrappedMap!, markers, {
      imagePath: `${process.env.BASE_URL}assets/marker-icons/m`
    });
    
  }

  private prepareMarkerInfo(farmsCentroid: FarmCentroid) {

    const modalInfoBody = this.prepareSimpleInfo(farmsCentroid);
    const marker = this.createMapLabel( new google.maps.LatLng(farmsCentroid.lat, farmsCentroid.lon), farmsCentroid.name);
    const uuid = farmsCentroid.uuid;

    this.markerHover(marker, modalInfoBody, uuid);
    return marker;
  }

  private prepareSimpleInfo(farmsCentroid: FarmCentroid){
    return `<div class="info-body">
              <h2 class="info-body--title"><span class="info-body--subtitle">${this.$t('farms-home.farms-map.farm-name')}</span> ${farmsCentroid.name}</h2>
              <p><span class="info-body--subtitle">${this.$t('farms-home.farms-map.owner')}</span> ${farmsCentroid.owner? farmsCentroid.owner : ''}</p>
              <button type="button"class="button is-outlined is-primary" onclick="viewMore('${farmsCentroid.uuid}')"> <i class="icon-eye" style="font-size: 18px; color: #BABABA;"></i>${this.$t('farms-home.farms-map.view-more')}</button></div>`;
  }

  private prepareFullInfo(farmMapSummary: FarmMapSummary, uuid: string) {
    return `<div class="info-body">
              <h2 class="info-body--title"> <span class="info-body--subtitle">${this.$t('farms-home.farms-map.farm-name')}</span> ${farmMapSummary.name}</h2>
              <p> <span class="info-body--subtitle">${this.$t('farms-home.farms-map.owner')}</span> ${farmMapSummary.owner ? farmMapSummary.owner : ''}</p>
              <p><span class="info-body--subtitle">${this.$t('farms-home.farms-map.city-state')}</span> ${farmMapSummary.city? farmMapSummary.city : ''}-${farmMapSummary.state ? farmMapSummary.state : '' }</p>
              <button type="button"class="button is-outlined is-primary" onclick="viewMore('${uuid}')"> <i class="icon-eye" style="font-size: 18px; color: #BABABA;"> </i> ${this.$t('farms-home.farms-map.view-more')}</button>
            </div>`;
  }
  

  private removeFarmMarkers() {
    if (!!this.farmMarkers) {
      this.farmMarkers!.clearMarkers();
      this.farmMarkers = null;
    }
  }

  private createMapLabel(position: google.maps.LatLng, title: string) {
    return new window.google.maps.Marker({
      position,
      draggable: false,
      label: {
        text: title,
        color: '#fff',
        fontWeight:'bold'
      },
      clickable: true,
    });
  }


  private registerListener(listener: google.maps.MapsEventListener) {
    this.listeners.push(listener);
  }

  private unregisterListeners() {  
    this.listeners.forEach((listener) => {
      window.google.maps.event.removeListener(listener);
    });
  }

  private displayCoordinates(pnt: google.maps.LatLng) {
    const lat = pnt.lat().toFixed(4);
    const lng = pnt.lng().toFixed(4);
    this.coordinatesString = this.$t("core.wrapped-gm.latLngLabel", {
      lat,
      lng,
    }) as string;
  }

  private zoomIn() {
    if (!!this.wrappedMap) {
      this.wrappedMap.setZoom(this.wrappedMap.getZoom() + 1);
    }
  }

  private zoomOut() {
    if (!!this.wrappedMap) {
      this.wrappedMap.setZoom(this.wrappedMap.getZoom() - 1);
    }
  }

  private get mapStyle() {
    const style = [this.mapClass];
    if (this.disabled) {
      style.push("is-disabled");
    }
    return style;
  }

  private markerHover(marker: google.maps.Marker, markerInfo: string, uuid: string) {
     const infoWindow = new google.maps.InfoWindow({
      content: markerInfo,
    })

      this.registerListener(
      marker.addListener("mouseover", async () => {
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      this.removePolygon();
      this.infoWindow = infoWindow;
      infoWindow.open(marker.get("map"), marker);
      await this.getFarmMapSummary(uuid);
      marker.setAnimation(google.maps.Animation.BOUNCE);
       setTimeout(()=>{
         marker.setAnimation(null);
      }, 2000);
      if(this.farmMapSummary ){
        infoWindow.setContent(this.prepareFullInfo(this.farmMapSummary, uuid));
        infoWindow.open(marker.get("map"), marker);
      }
    })
    )

    this.registerListener(
      infoWindow.addListener("closeclick", ()=> {
        this.removePolygon();
      })
    )
  }

  private async getFarmMapSummary(uuid: string) {
    this.isLoading = true;
    this.farmMapSummary = null;
    try {
      const response = (await farmsApi.getFarmMapSummary(uuid)).data;
      this.farmMapSummary = response;
      this.loadPolygon(this.farmMapSummary!.geom);
    } catch {
      this.farmMapSummary = null;
    } finally {
      this.isLoading = false;
    }
  }


  private loadPolygon(polygon: GeoJSONGeometry) {
    requestAnimationFrame(() => {
      const props = {
      fill: "#eecb11",
      "fill-opacity": 0.2,
      stroke: "#eecb11",
      "stroke-width": 4,
    };
      const feature = wrapGeometryObject(polygon, props);
      this.wrappedMap!.data.addGeoJson(feature, );
    });
  }

  private removePolygon() {
    this.wrappedMap!.data.forEach(feature => {
      this.wrappedMap!.data.remove(feature);
    });
  }

  private setupPolygonStyle() {
    requestAnimationFrame(() => {
      this.wrappedMap!.data.setStyle(feature => {
        const fillColor = feature.getProperty('fill') || "#555555";
        const fillOpacity = feature.getProperty('fill-opacity') || 0.5;
        const strokeColor = feature.getProperty('stroke') || "#555555";
        const strokeOpacity = feature.getProperty('stroke-opacity') || 1.0;
        const strokeWeight = feature.getProperty('stroke-width') || 2;
        const isClickable = feature.getProperty('id') !== null;

        return {
          clickable: isClickable,
          fillColor,
          fillOpacity,
          strokeColor,
          strokeOpacity,
          strokeWeight,
        };
      });
    });
  }

  private viewMore(uuid: string) {
    this.$emit("viewMoreAction", uuid);
  }

}
